// Package Block
import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { Redirect } from "react-router-dom";

// Custom Component & Redux Block
// import { LayoutSplashScreen } from "../../../../_metronic/layout";
import * as auth from "../_redux/authRedux";

const Logout =()=>{
  const dispatch = useDispatch();
  // const { hasAuthToken } = this.props;

  useEffect(()=>{
    localStorage.removeItem("accounting_banking_pin_verified");
    dispatch(auth.actions.logout())
  }, [])
   // return hasAuthToken ? <LayoutSplashScreen /> : <Redirect to="/auth/login" />;
    return <Redirect to="/auth/login" />;
}

export default connect(({ auth }) => ({ hasAuthToken: Boolean(auth.authToken) }), auth.actions)(Logout);
